import { objectToString } from '@symbo.ls/utils'
import { compileToHtml } from './htmlfy.js'
// import { convert } from 'domql-to-mitosis/src/convert'

export const stringifyProps = (props, indent = 2) => objectToString(props, indent)

// FA207 / frank trap — a bare sibling-export call (stringifyProps) is
// unresolvable once this file's exports are individually frank.toJSON'd for
// platform delivery (project_frank_drops_module_local_helpers). Inlined.
export const codify = (key, demoProps, appKey, opts = {}) => {
  const hasProps = demoProps && Object.keys(demoProps).length
  const props = hasProps ? objectToString(demoProps, 2) : '{}'
  const propsForHtml = {
    tag: key,
    ...demoProps
  }
  const html = compileToHtml(propsForHtml)
  const boxSize =
    opts.width && opts.height ? ` width: ${opts.width}px; height: ${opts.height}px;` : ''

  return {
    symbols: `{
  ${key}: ${props}
}`,

    domql: `import { ${key} } from '~/smbls/${key}'

const MyComponent = {
  ${key}: ${props}
}`,

    react: hasProps
      ? `'use strict'

import React from 'react'
import { ${key} } from './${key}.js'

export const Component = () => {
  const props = ${props}
  return <${key} {...props} />
}`
      : `import { ${key} } from './${key}'

const MyComponent = props => {
  return <${key} {...props} />
}`,

    iframe: `<iframe
  title="${key}"
  style="border: 0; resize: both; padding: 0 10px 10px 0;${boxSize}"
  src="https://${appKey}/component?key=${key}&fullsize=true&hideUi=true" 
  referrerpolicy="no-referrer-when-downgrade"
></iframe>`,

    html
  }
}
